if (!customElements.get('delayed-popup')) {
  class DelayedPopup extends HTMLElement {
    constructor() {
      super();
      this.card = null;
      this.modal = null;
      this.layers = [];
      this.activeLayer = null;
      this.closeButtons = [];
      this.meetingsBtn = null;
      this.modalPhone = null;
      this.meetingsDivider = null;
      this.callback = null;
      this.callbackInput = null;
      this.callbackSubmit = null;
      this.callbackError = null;
      this.callbackSuccess = null;
      this.callbackTitleOpen = null;
      this.callbackTitleClosed = null;
      this.callbackSubtitleOpen = null;
      this.callbackSubtitleClosed = null;
      this.statusOpen = null;
      this.statusClosed = null;
      this.callbackWebhook = 'https://mintbikes.app.n8n.cloud/webhook/babad87a-00b5-46cb-82cd-56412a2b8a0e';
      this.timer = null;
      this.isOpen = false;
      this._advisorApplied = false;
      this.storageKey = 'mb-delayed-popup-seen';
      this.dismissedKey = 'mb-delayed-popup-dismissed';
      this.viewCountKey = 'mb-product-view-count';
      this.delaySeconds = 5;
      this.showOnView = 1;
      this.frequency = 'once_session';
      this.testMode = false;
      this.lastFocused = null;
      this._prevOverflow = undefined;
      this.mobileQuery = window.matchMedia('(max-width: 767px)');
      this._handleKeydown = this._handleKeydown.bind(this);
      this._handleClose = this._handleClose.bind(this);
      this._handleBackdrop = this._handleBackdrop.bind(this);
      this._handleMeetings = this._handleMeetings.bind(this);
      this._handleMediaChange = this._handleMediaChange.bind(this);
      this._handleCallbackSubmit = this._handleCallbackSubmit.bind(this);
    }

    connectedCallback() {
      this.card = this.querySelector('.delayed-popup__card');
      this.modal = this.querySelector('.delayed-popup__modal');
      this.layers = [this.card, this.modal].filter(Boolean);
      if (!this.layers.length) return;

      this.closeButtons = Array.from(this.querySelectorAll('.delayed-popup__close, .delayed-popup__modal-close'));
      this.meetingsBtn = this.querySelector('.delayed-popup__modal-meetings');

      // Bascule horaires : le CTA téléphone + le séparateur « ou » ne s'affichent que
      // pendant les horaires ; le formulaire de rappel reste toujours visible.
      this.modalPhone = this.querySelector('.delayed-popup__modal-phone');
      this.meetingsDivider = this.querySelector('.delayed-popup__modal-divider');
      this.callback = this.querySelector('.delayed-popup__modal-callback');
      if (this.callback) {
        this.callbackInput = this.callback.querySelector('.delayed-popup__modal-callback-input');
        this.callbackSubmit = this.callback.querySelector('.delayed-popup__modal-callback-submit');
        this.callbackError = this.callback.querySelector('.delayed-popup__modal-callback-error');
        this.callbackSuccess = this.callback.querySelector('.delayed-popup__modal-callback-success');
        // Wording ouvert/fermé (basculé dans _applyOpeningState).
        this.callbackTitleOpen = this.callback.querySelector('.delayed-popup__modal-callback-title--open');
        this.callbackTitleClosed = this.callback.querySelector('.delayed-popup__modal-callback-title--closed');
        this.callbackSubtitleOpen = this.callback.querySelector('.delayed-popup__modal-callback-subtitle--open');
        this.callbackSubtitleClosed = this.callback.querySelector('.delayed-popup__modal-callback-subtitle--closed');
      }
      this.statusOpen = this.querySelector('.delayed-popup__modal-advisor-status--open');
      this.statusClosed = this.querySelector('.delayed-popup__modal-advisor-status--closed');

      this.delaySeconds = parseInt(this.getAttribute('data-delay-seconds'), 10) || 0;
      this.testMode = this.getAttribute('data-test-mode') === 'true';
      this.storageKey = this.getAttribute('data-storage-key') || this.storageKey;

      // La pop-up n'est pas rendue pour cet appareil (CSS display:none) : on sort avant
      // d'ouvrir, sinon on tracke une impression fantôme et on consomme la fréquence.
      var device = this.getAttribute('data-device') || 'both';
      var isMobile = this._isMobile();
      if (device === 'desktop' && isMobile) return;
      if (device === 'mobile' && !isMobile) return;

      // Fréquence et seuil de déclenchement sont réglés séparément par appareil :
      // le toast desktop est discret, le modal mobile est bloquant.
      var showOnViewAttr = isMobile ? 'data-show-on-view-mobile' : 'data-show-on-view-desktop';
      var frequencyAttr = isMobile ? 'data-frequency-mobile' : 'data-frequency-desktop';
      this.showOnView = parseInt(this.getAttribute(showOnViewAttr), 10) || 1;
      this.frequency = this.getAttribute(frequencyAttr) || 'once_session';

      // Hors mode test : on compte les fiches vues dans la session et on n'affiche qu'à
      // partir de la Nième. Deux verrous distincts ensuite :
      //  - `dismissed` (tous modes) : le visiteur a fermé la pop-up → terminé pour la session ;
      //  - `seen` (mode 'once_session' seulement) : posé dès l'affichage → une seule apparition.
      if (!this.testMode) {
        var viewCount = this._bumpProductViewCount();
        if (this._hasBeenDismissed()) return;
        if (this.frequency !== 'every_page' && this._hasBeenSeen()) return;
        if (viewCount < this.showOnView) return;
      }

      // Rotation conseiller : applique l'avatar + prénom sélectionné pour la session
      // (avant le timer d'ouverture → l'avatar se charge pendant le délai).
      this._applyAdvisor();

      this.closeButtons.forEach((btn) => btn.addEventListener('click', this._handleClose));
      this.addEventListener('click', this._handleBackdrop);
      if (this.meetingsBtn) this.meetingsBtn.addEventListener('click', this._handleMeetings);
      if (this.callbackSubmit) this.callbackSubmit.addEventListener('click', this._handleCallbackSubmit);
      this.mobileQuery.addEventListener('change', this._handleMediaChange);

      if (this.testMode) {
        // Mode test : affichage immédiat, sans persistance.
        this.open();
      } else {
        this.timer = window.setTimeout(() => this.open(), this.delaySeconds * 1000);
      }
    }

    disconnectedCallback() {
      if (this.timer) window.clearTimeout(this.timer);
      window.removeEventListener('keydown', this._handleKeydown);
      this.mobileQuery.removeEventListener('change', this._handleMediaChange);
      this._unlockScroll();
    }

    _hasBeenSeen() {
      try {
        return window.sessionStorage.getItem(this.storageKey) === '1';
      } catch (e) {
        return false;
      }
    }

    _markAsSeen() {
      try {
        window.sessionStorage.setItem(this.storageKey, '1');
      } catch (e) {
        /* sessionStorage indisponible : on ignore silencieusement */
      }
    }

    // Fermeture explicite par le visiteur : signal fort, la pop-up ne revient plus de la
    // session — y compris en mode 'every_page'. Clé distincte de `seen` (qui, lui, est posé
    // à la simple ouverture) pour ne pas confondre « déjà affichée » et « refusée ».
    _hasBeenDismissed() {
      try {
        return window.sessionStorage.getItem(this.dismissedKey) === '1';
      } catch (e) {
        return false;
      }
    }

    _markAsDismissed() {
      try {
        window.sessionStorage.setItem(this.dismissedKey, '1');
      } catch (e) {
        /* sessionStorage indisponible : on ignore silencieusement */
      }
    }

    _bumpProductViewCount() {
      try {
        // Comptage IDEMPOTENT : un seul +1 par chargement de page. connectedCallback peut se
        // déclencher plusieurs fois sur une même page (observé sur Android : double connexion /
        // re-insertion du custom element → le compteur montait de 2 dès la 1re fiche, d'où le
        // pop-up trop tôt vs iPhone). Le flag window (neuf à chaque navigation) garantit 1 seul +1.
        if (window.__mbProductViewCounted) {
          return parseInt(window.sessionStorage.getItem(this.viewCountKey), 10) || 1;
        }
        window.__mbProductViewCounted = true;
        var n = (parseInt(window.sessionStorage.getItem(this.viewCountKey), 10) || 0) + 1;
        window.sessionStorage.setItem(this.viewCountKey, String(n));
        return n;
      } catch (e) {
        // sessionStorage indisponible : impossible de compter → on se comporte
        // comme si on était sur la 1re vue.
        return 1;
      }
    }

    // Sélection d'un conseiller stable pour la session, par IDENTITÉ (id metaobject) et non par
    // position ni prénom : l'ordre de metaobjects.conseiller.values n'est pas garanti stable, et
    // deux conseillers peuvent partager un prénom. On persiste l'id et on le re-résout par page.
    _pickAdvisorIndex(roster) {
      var key = 'mb-advisor-id';
      try {
        var stored = window.sessionStorage.getItem(key);
        if (stored !== null) {
          for (var i = 0; i < roster.length; i++) {
            if (roster[i].id === stored) return i;
          }
        }
        var pick = Math.floor(Math.random() * roster.length);
        window.sessionStorage.setItem(key, roster[pick].id);
        return pick;
      } catch (e) {
        return Math.floor(Math.random() * roster.length);
      }
    }

    // Applique le conseiller sélectionné : avatar (1 seul fetch), prénom (titre + label),
    // aria-label du toast, et expose le prénom au tracking via dataset.advisorName.
    _applyAdvisor() {
      if (this._advisorApplied) return;
      this._advisorApplied = true;
      // Par défaut, expose le prénom de repli au tracking (écrasé plus bas si un roster existe).
      this.dataset.advisorName = this.getAttribute('data-fallback-advisor') || '';
      var script = this.querySelector('.delayed-popup__roster');
      if (!script) return;
      var roster;
      try {
        roster = JSON.parse(script.textContent);
      } catch (e) {
        return;
      }
      if (!roster || !roster.length) return;

      var index;
      if (window.Shopify && window.Shopify.designMode) {
        index = 0; // aperçu éditeur : conseiller stable
      } else if (this.testMode) {
        index = Math.floor(Math.random() * roster.length); // mode test : re-tire à chaque reload
      } else {
        index = this._pickAdvisorIndex(roster); // tirage persisté par session (par identité)
      }
      var advisor = roster[index];
      if (!advisor) return;

      var prenom = advisor.prenom || '';
      var toastImg = this.querySelector('.delayed-popup__media img');
      if (toastImg && advisor.avatar) {
        toastImg.src = advisor.avatar;
        toastImg.alt = prenom;
      }
      var modalImg = this.querySelector('.delayed-popup__modal-avatar');
      if (modalImg && advisor.avatarSm) modalImg.src = advisor.avatarSm;

      var titleTpl = this.getAttribute('data-title-template') || '';
      var labelTpl = this.getAttribute('data-label-template') || '';
      var titleText = titleTpl.split('{prenom}').join(prenom);
      var titleEl = this.querySelector('.delayed-popup__title');
      if (titleEl && titleTpl) titleEl.textContent = titleText;
      var nameEl = this.querySelector('.delayed-popup__modal-advisor-name');
      if (nameEl && labelTpl) nameEl.textContent = labelTpl.split('{prenom}').join(prenom);
      if (this.card && titleTpl) this.card.setAttribute('aria-label', titleText);

      this.dataset.advisorName = prenom;
    }

    _isMobile() {
      return this.mobileQuery.matches;
    }

    open() {
      if (this.isOpen) return;
      this.isOpen = true;

      // On ne dé-masque QUE la couche active selon le viewport (fix H3/H4 :
      // évite de dépendre des !important croisés pour re-masquer l'autre couche).
      this.activeLayer = this._isMobile() ? this.modal : this.card;
      if (!this.activeLayer) this.activeLayer = this.modal || this.card;
      this.activeLayer.style.display = '';

      // Force reflow pour que la transition CSS s'applique.
      this.offsetHeight;

      this.classList.add('is-visible');
      window.addEventListener('keydown', this._handleKeydown);

      if (this._isMobile() && this.activeLayer === this.modal) {
        this.lastFocused = document.activeElement;
        // Masque le téléphone + séparateur hors horaires (formulaire de rappel toujours
        // visible) + statut conseiller, avant de placer le focus sur un élément visible.
        this._applyOpeningState();
        this._lockScroll();
        this._focusModal();
      }

      // Mode « une seule fois par session » : le verrou tombe dès l'affichage, sans attendre
      // une fermeture (le visiteur peut très bien naviguer sans jamais fermer la pop-up).
      if (!this.testMode && this.frequency === 'once_session') this._markAsSeen();

      // Impression trackée desktop ET mobile (le device est passé dans le CustomEvent).
      this._trackOpen();
    }

    // reason 'viewport' = fermeture technique (franchissement du breakpoint), pas une
    // intention du visiteur : elle ne doit donc pas condamner la pop-up pour la session.
    close(reason) {
      if (!this.isOpen) return;
      this.isOpen = false;

      this.classList.remove('is-visible');
      window.removeEventListener('keydown', this._handleKeydown);
      this._unlockScroll();
      this._restoreFocus();

      if (!this.testMode && reason !== 'viewport') this._markAsDismissed();

      // Laisse l'animation de sortie se terminer avant de retirer du flux.
      const layer = this.activeLayer;
      window.setTimeout(() => {
        if (this.isOpen) return; // ré-ouvert entre temps
        if (layer) layer.style.display = 'none';
      }, 300);
    }

    _handleClose(e) {
      e.preventDefault();
      e.stopPropagation();
      // CTA « Fermer » (toast desktop ou modal mobile) → tracking, symétrique de l'ouverture.
      // Le pont vers le dataLayer vit dans tracking-ecommerce.liquid (payload produit en Liquid).
      // e.stopPropagation() ci-dessus empêcherait un listener délégué sur document → on passe
      // par un CustomEvent dispatché ici, comme _trackOpen. (Escape/overlay ne passent pas ici.)
      this._trackClose();
      this.close();
    }

    _handleBackdrop(e) {
      // Clic sur l'overlay (hors carte), en mobile : fermer. Tracké comme "dismiss"
      // (distinct du bouton « Fermer » = "close") pour différencier l'intention.
      if (this._isMobile() && e.target === this) {
        this._trackClose('dismiss');
        this.close();
      }
    }

    _handleMeetings() {
      // Le clic ouvre la modale HubSpot via .x-button__meetings-modal (x-modal.js,
      // listener bubble sur document). Ce handler s'exécute en phase target, AVANT,
      // donc on ferme le modal Geoffrey pour éviter deux overlays superposés.
      this.close();
    }

    _handleMediaChange() {
      // Franchissement du breakpoint pendant l'ouverture (rotation/resize) :
      // on ferme pour éviter un overlay orphelin et un scroll-lock bloqué (fix M1).
      if (this.isOpen) this.close('viewport');
    }

    _handleKeydown(e) {
      if (e.key === 'Escape') {
        this.close();
        return;
      }
      if (e.key === 'Tab' && this._isMobile() && this.modal) {
        this._trapFocus(e);
      }
    }

    _focusableEls() {
      if (!this.modal) return [];
      return Array.from(
        this.modal.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'),
      ).filter((el) => el.offsetParent !== null);
    }

    _focusModal() {
      const els = this._focusableEls();
      if (els.length) {
        els[0].focus();
      } else if (this.modal) {
        this.modal.setAttribute('tabindex', '-1');
        this.modal.focus();
      }
    }

    _trapFocus(e) {
      const els = this._focusableEls();
      if (!els.length) return;
      const first = els[0];
      const last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    _restoreFocus() {
      if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
        this.lastFocused.focus();
      }
      this.lastFocused = null;
    }

    _lockScroll() {
      this._prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
    }

    _unlockScroll() {
      if (this._prevOverflow !== undefined) {
        document.documentElement.style.overflow = this._prevOverflow;
        this._prevOverflow = undefined;
      }
    }

    _trackOpen() {
      this.dispatchEvent(
        new CustomEvent('delayed-popup:open', {
          bubbles: true,
          detail: { device: this._isMobile() ? 'mobile' : 'desktop' },
        }),
      );
    }

    _trackClose(reason) {
      this.dispatchEvent(
        new CustomEvent('delayed-popup:close', {
          bubbles: true,
          detail: { device: this._isMobile() ? 'mobile' : 'desktop', reason: reason || 'close' },
        }),
      );
    }

    _applyOpeningState() {
      // Le formulaire de rappel reste TOUJOURS visible ; seul son wording bascule
      // ouvert/fermé. On masque en plus le CTA téléphone et le séparateur « ou » hors
      // horaires (+ statut ouvert/fermé).
      var hasToggle = this.modalPhone || this.meetingsDivider || this.callback || this.statusOpen || this.statusClosed;
      if (!hasToggle) return;

      // Par défaut : ligne considérée ouverte (fallback si PhoneStatusUtils absent
      // ou JSON invalide) → on montre le téléphone + le séparateur.
      var isOpen = true;
      var utils = window.PhoneStatusUtils;
      if (utils && typeof utils.isPhoneLineOpen === 'function') {
        try {
          var hours = utils.parseOpeningHours(this.getAttribute('data-phone-opening-hours'));
          isOpen = utils.isPhoneLineOpen(hours);
        } catch (e) {
          isOpen = true;
        }
      }

      // Ouvert → téléphone + séparateur « ou » ; Fermé → uniquement le formulaire de rappel.
      if (this.modalPhone) this.modalPhone.style.display = isOpen ? '' : 'none';
      if (this.meetingsDivider) this.meetingsDivider.style.display = isOpen ? '' : 'none';
      // Wording du formulaire de rappel selon l'ouverture.
      if (this.callbackTitleOpen) this.callbackTitleOpen.style.display = isOpen ? '' : 'none';
      if (this.callbackTitleClosed) this.callbackTitleClosed.style.display = isOpen ? 'none' : '';
      if (this.callbackSubtitleOpen) this.callbackSubtitleOpen.style.display = isOpen ? '' : 'none';
      if (this.callbackSubtitleClosed) this.callbackSubtitleClosed.style.display = isOpen ? 'none' : '';
      if (this.statusOpen) this.statusOpen.style.display = isOpen ? '' : 'none';
      if (this.statusClosed) this.statusClosed.style.display = isOpen ? 'none' : '';
    }

    _validatePhone(phone) {
      if (typeof window.validateFrenchPhoneNumber === 'function') {
        return window.validateFrenchPhoneNumber(phone);
      }
      return /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/.test(phone);
    }

    _resetCallbackMessages() {
      if (this.callbackError) {
        this.callbackError.hidden = true;
        this.callbackError.textContent = '';
      }
      if (this.callbackSuccess) {
        this.callbackSuccess.hidden = true;
        this.callbackSuccess.textContent = '';
      }
    }

    async _handleCallbackSubmit() {
      if (!this.callbackInput) return;
      var phoneNumber = this.callbackInput.value.trim();
      this._resetCallbackMessages();

      if (!phoneNumber) {
        this.callbackError.textContent = 'Veuillez entrer votre numéro de téléphone';
        this.callbackError.hidden = false;
        return;
      }
      if (!this._validatePhone(phoneNumber)) {
        this.callbackError.textContent = 'Veuillez entrer un numéro de téléphone français valide';
        this.callbackError.hidden = false;
        return;
      }

      this.callbackSubmit.disabled = true;

      try {
        var response = await fetch(this.callbackWebhook, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ phone: phoneNumber }),
        });

        if (!response.ok) {
          throw new Error("Erreur lors de l'envoi");
        }

        this.callbackSuccess.textContent = 'Un conseiller va vous rappeler';
        this.callbackSuccess.hidden = false;
        this.callbackInput.value = '';
      } catch (error) {
        this.callbackError.textContent = 'Une erreur est survenue. Veuillez réessayer.';
        this.callbackError.hidden = false;
      } finally {
        this.callbackSubmit.disabled = false;
      }
    }
  }

  customElements.define('delayed-popup', DelayedPopup);
}
